//import CardBlock from '../components/bodyBlocks/cardsBlock/CardsBlock'
import CardBlock from '../components/bodyBlocks/cardsBlock/cardsBlock'

import '../index.css'

function Principal() {
  return (

      <CardBlock />

  )
}

export default Principal

